import {
    DATASET_DRY_CARGO,
    DATASET_LPG_VLGC,
    DATASET_PCG,
    DATASET_SPECIALISED,
    DATASET_LPG_MIDSIZE,
    DATASET_LNG,
} from '../models/Datasets';

export const getDefaultOrdersRowGroups = (datasetId) => {
    if (!datasetId) return [];
    switch (datasetId) {
        case DATASET_DRY_CARGO:
            return [
                { colId: 'thirdPartyCharterer', checked: false },
                { colId: 'cargoQuantity', checked: false },
                { colId: 'cargoParts', checked: false },
                { colId: 'loadZones', checked: false },
                { colId: 'areasGeared', checked: false },
                { colId: 'areas', checked: true },
                { colId: 'groupName', checked: false },
                { colId: 'quoted', checked: false },
                { colId: 'direction', checked: false },
                { colId: 'type', checked: false },
                { colId: 'vesselCategory', checked: false },
            ];
        case DATASET_SPECIALISED:
            return [
                { colId: 'charterer', checked: false },
                { colId: 'cargoQuantity', checked: false },
                { colId: 'cargoParts', checked: false },
                { colId: 'loadZones', checked: false },
                { colId: 'areas', checked: true },
                { colId: 'groupName', checked: false },
                { colId: 'quoted', checked: false },
                { colId: 'type', checked: false },
                { colId: 'buyer', checked: false },
                { colId: 'opportunity', checked: false },
                { colId: 'operator', checked: false },
            ];
        default:
            return [
                { colId: 'charterer', checked: false },
                { colId: 'cargoQuantity', checked: false },
                { colId: 'cargoParts', checked: false },
                { colId: 'loadZones', checked: false },
                { colId: 'areas', checked: true },
                { colId: 'groupName', checked: false },
                { colId: 'quoted', checked: false },
                { colId: 'type', checked: false },
                { colId: 'vesselCategory', checked: false },
            ];
    }
};

export const getDefaultFixturesRowGroups = (datasetId) => {
    switch (datasetId) {
        case DATASET_DRY_CARGO:
            return [
                { colId: 'thirdPartyCharterer', checked: false },
                { colId: 'cargoQuantity', checked: false },
                { colId: 'cargoParts', checked: false },
                { colId: 'loadZones', checked: false },
                { colId: 'areasGeared', checked: false },
                { colId: 'areas', checked: false },
                { colId: 'groupName', checked: false },
                { colId: 'quoted', checked: false },
                { colId: 'direction', checked: false },
                { colId: 'vesselCategory', checked: false },
                { colId: 'type', checked: false },
                { colId: 'cpDate', checked: false },
            ];
        case DATASET_PCG:
            return [
                { colId: 'charterer', checked: false },
                { colId: 'cargoQuantity', checked: false },
                { colId: 'cargoParts', checked: false },
                { colId: 'loadZones', checked: false },
                { colId: 'areas', checked: false },
                { colId: 'groupName', checked: false },
                { colId: 'vesselCategory', checked: false },
                { colId: 'type', checked: false },
                { colId: 'cpDate', checked: false },
            ];
        case DATASET_LNG:
            return [
                { colId: 'charterer', checked: false },
                { colId: 'cargoQuantity', checked: false },
                { colId: 'cargoParts', checked: false },
                { colId: 'loadZones', checked: false },
                { colId: 'areas', checked: false },
                { colId: 'groupName', checked: false },
                { colId: 'vesselCategory', checked: false },
                { colId: 'type', checked: false },
                { colId: 'cpDate', checked: false },
            ];
        case DATASET_LPG_VLGC:
        case DATASET_LPG_MIDSIZE:
            return [
                { colId: 'charterer', checked: false },
                { colId: 'cargoQuantity', checked: false },
                { colId: 'cargoParts', checked: false },
                { colId: 'loadZones', checked: false },
                { colId: 'areas', checked: false },
                { colId: 'groupName', checked: false },
                { colId: 'vesselCategory', checked: false },
                { colId: 'type', checked: true },
                { colId: 'cpDate', checked: false },
            ];
        default:
            return [
                { colId: 'charterer', checked: false },
                { colId: 'cargoQuantity', checked: false },
                { colId: 'cargoParts', checked: false },
                { colId: 'loadZones', checked: false },
                { colId: 'areas', checked: false },
                { colId: 'groupName', checked: false },
                { colId: 'quoted', checked: false },
                { colId: 'vesselCategory', checked: false },
                { colId: 'type', checked: false },
                { colId: 'cpDate', checked: false },
            ];
    }
};
